import React, { useState, useEffect, useRef } from "react";

interface MultiSelectDropdownProps {
	options: Array<{ label: string; value: any } | string>;
	value: any[];
	onChange: (value: any[]) => void;
	placeholder?: string;
	className?: string; // Adicionei esta prop para aceitar classes adicionais
}

const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({
	options,
	value,
	onChange,
	placeholder,
	className,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef<HTMLDivElement>(null);

	const handleOptionChange = (optionValue: any) => {
		let newValue = [...value];
		if (newValue.includes(optionValue)) {
			newValue = newValue.filter((val) => val !== optionValue);
		} else {
			newValue.push(optionValue);
		}
		onChange(newValue);
	};

	const selectedLabels = options
		.filter((option: any) => value.includes(option.value || option))
		.map((option: any) => option.label || option)
		.join(", ");

	const handleClickOutside = (event: MouseEvent) => {
		if (
			dropdownRef.current &&
			!dropdownRef.current.contains(event.target as Node)
		) {
			setIsOpen(false);
		}
	};

	useEffect(() => {
		if (isOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		} else {
			document.removeEventListener("mousedown", handleClickOutside);
		}
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isOpen]);

	return (
		<div className="relative min-w-full min-h-full" ref={dropdownRef}>
			<button
				type="button"
				onClick={() => setIsOpen(!isOpen)}
				className={`w-full h-full pl-6 py-2 bg-transparent text-left text-[.9rem] border-b-2 border-gray-300 focus:outline-none focus:border-amber-400 hover:border-amber-400 ${className}`}
			>
				{selectedLabels || placeholder || "Selecione opções"}
			</button>
			{isOpen && (
				<div className="absolute z-50 mt-1 bg-gray-700 border border-gray-600 rounded shadow-lg max-h-48 overflow-auto w-full">
					{options.map((option: any, index: number) => {
						const optionValue = option.value || option;
						const optionLabel = option.label || option;
						const isChecked = value.includes(optionValue);
						return (
							<label
								key={index}
								className="flex items-center px-2 py-1 cursor-pointer hover:bg-gray-600"
							>
								<input
									type="checkbox"
									checked={isChecked}
									onChange={() => handleOptionChange(optionValue)}
									className="form-checkbox h-4 w-4 text-amber-400"
								/>
								<span className="ml-2">{optionLabel}</span>
							</label>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default MultiSelectDropdown;
